<template>
  <div class="element-select">
    <Select :disabled='disabled' v-if="!readonly" :label-in-value="true" v-model="currentValue" filterable @on-change="change">
      <Option v-for="item in options" :value="item.value" :key="item.id || item.value">{{ item.label }}</Option>
    </Select>
    <label v-else>{{label}}</label>
  </div>
</template>

<script>
export default {
  name: 'elementSelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelProp: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  created () {
    this.currentValue = this.value;
  },
  watch: {
    value: function (val) {
      this.currentValue = val;
    }
  },
  methods: {
    change (selectedOne) {
      if (selectedOne) {
        this.$emit('input', this.currentValue);
        this.$emit('on-change');
        if (this.labelProp !== 'bankProvince' && this.labelProp !== 'bankName') {
          this.$emit('on-label-change', this.labelProp, selectedOne.label);
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/select.vue